import { z } from "zod";

export const cxFeatureFlagsSchema = z.object({
  cxsWithDashV2FeatureFlag: z.literal(true).optional(),
});
export type CxFeatureFlags = z.infer<typeof cxFeatureFlagsSchema>;
